export {
  buildCanonicalProductPath,
  buildCategoryPathFromTrail,
  getCategoryImageUrl,
  getCategoryImageSources,
  resolveCategoryFromPath,
} from './routing/categoryPaths'
export {
  buildProductPathFromIdentity,
  buildShortProductPath,
  normalizeProductPublicCode,
} from './routing/productPaths'
export { inferErrorCode } from './routing/errorCode'
export { normalizePathname } from './routing/pathname'
export { parseRoute } from './routing/routeParsing'
